import {axiosServerInstance} from "../../config/api/axios";
import {notifyApiErrorMessage} from "../notifications/notifyApiErrorMessage";

export class APIUtils {
    static formatQueryDictToQueryParams(data, prefix = "") {
        const params = []
        console.log(data, "dddddddddd")
        for (let item of Object.keys(data)) {
            params.push(`${item}=${data[item]}`)
        }
        return params.length ? `${prefix}${params.join('&')}` : ''
    }

    static dataStateMutator(oldState, newData, setterFunc) {
        const newState = {
            ...(oldState || {}),
            ...(newData || {})
        }
        setterFunc(newState)
        return newState
    }

    static async fetchListingAllPagination(endpoint, countLimit) {
        let tempData = []
        let errorEncountered = false;
        let breakLoop = false;
        while (true) {
            await axiosServerInstance()
                .get(endpoint)
                .then((response) => {
                    tempData = [...tempData, ...response.data]
                    if (countLimit && tempData.length >= countLimit) {
                        tempData = tempData.slice(0, countLimit)
                        breakLoop = true
                    }
                    if (response?.data?.next) {
                        endpoint = response?.data?.next
                    } else {
                        breakLoop = true;
                    }
                })
                .catch((err) => {
                    notifyApiErrorMessage(err)
                    errorEncountered = true
                    breakLoop = true
                });
            if (breakLoop) {
                break
            }
        }
        if (!errorEncountered) {
            return tempData
        }
    }

    static async fetchItemData({
                                   endpoint,
                                   item,
                                   setItem,
                                   isFetchingValueOnTrue,
                                   callBackOnErr,
                                   customAccessToken,
                                   notifyApiErrorMessageMessage = true,
                                   customErrorMessage,
                                   fetchAsAppendMode = false,
                                   fetchAllListItem = true,
                                   fetchAllListItemLimit = 100
                               }) {
        let oldState = {
            ...item,
        }
        oldState = APIUtils.dataStateMutator(oldState, {isFetching: isFetchingValueOnTrue || true}, setItem)
        await axiosServerInstance(customAccessToken).get(endpoint).then(async (response) => {
            if (response?.data?.results) {
                if (response?.data?.next && fetchAllListItem) {
                    oldState = APIUtils.dataStateMutator(oldState, {data: await APIUtils.fetchListingAllPagination(endpoint, fetchAllListItemLimit)}, setItem)
                } else {
                    oldState = APIUtils.dataStateMutator(oldState, {data: response?.data?.results}, setItem)
                }
            } else {
                if (fetchAsAppendMode) {
                    oldState = APIUtils.dataStateMutator(oldState, {data: [...(oldState.data || []), ...response.data]}, setItem)
                } else {
                    oldState = APIUtils.dataStateMutator(oldState, {data: response.data}, setItem)
                }
            }
        }).catch((err) => {
            notifyApiErrorMessageMessage && notifyApiErrorMessage(customErrorMessage || err)
            callBackOnErr && callBackOnErr()
        })
        APIUtils.dataStateMutator(oldState, {isFetching: false}, setItem)
    }


    static async editItemData({endpoint, item, setItem, payload, callBackOnErr, customAccessToken}) {
        const tempItem = APIUtils.dataStateMutator({...item}, {
            data: {...item.data, ...payload}
        }, setItem)
        await axiosServerInstance(customAccessToken).patch(
            endpoint,
            payload
        ).catch((err) => {
            notifyApiErrorMessage(err);
            callBackOnErr && callBackOnErr()
        });
        await APIUtils.fetchItemData({
            endpoint: endpoint,
            item: tempItem,
            setItem
        })
    }

    static parseEndpointForQueryParams({endpoint, params}) {
        return `${endpoint}${params ? APIUtils.formatQueryDictToQueryParams(params, '?') : ''}`
    }
}